function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ModulesTemplate = require('./modules.template');
var MODE_LABELS = {
  off: 'Off',
  both: 'Both',
  server: 'Server',
  client: 'Client'
};
var AdminModulesUI = /*#__PURE__*/function () {
  function AdminModulesUI(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.admin-modules';
    _classCallCheck(this, AdminModulesUI);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.modules = [];
    this.dirty = false;
    this.saved = false;
    this.error = '';
    this.filter = '';
  }
  return _createClass(AdminModulesUI, [{
    key: "render",
    value: function render() {
      this.error = '';
      this.saved = false;
      this.dirty = false;
      this.filter = '';
      if (!this.mod.server_info) {
        this.app.browser.replaceElementContentBySelector("<p class=\"admin-modules-empty\">Waiting for the server to finish authenticating this administrator.</p>", this.container);
        return;
      }
      this.modules = this.buildModuleList();
      this.refresh();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.app.browser.replaceElementContentBySelector(ModulesTemplate(this.modules, {
        dirty: this.dirty,
        saved: this.saved,
        error: this.error,
        filter: this.filter
      }), this.container);
      this.attachEvents();
      this.applyFilter();
    }
  }, {
    key: "buildModuleList",
    value: function buildModuleList() {
      var _this$mod$server_info,
        _this$mod$server_info2,
        _this = this;
      var available = ((_this$mod$server_info = this.mod.server_info) === null || _this$mod$server_info === void 0 ? void 0 : _this$mod$server_info.available_modules) || [];
      var config = ((_this$mod$server_info2 = this.mod.server_info) === null || _this$mod$server_info2 === void 0 ? void 0 : _this$mod$server_info2.module_config) || {
        core: [],
        lite: []
      };
      var core = new Set((config.core || []).map(function (entry) {
        return _this.moduleNameFromPath(entry);
      }));
      var lite = new Set((config.lite || []).map(function (entry) {
        return _this.moduleNameFromPath(entry);
      }));
      var seen = new Set();
      var modules = [];
      var _iterator = _createForOfIteratorHelper(available),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var name = _step.value;
          seen.add(name);
          modules.push({
            name: name,
            mode: this.modeFromLists(name, core, lite),
            missing: false
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var configured = [].concat(_toConsumableArray(core), _toConsumableArray(lite)).sort();
      var _iterator2 = _createForOfIteratorHelper(configured),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _name = _step2.value;
          if (!_name || seen.has(_name)) {
            continue;
          }
          modules.push({
            name: _name,
            mode: this.modeFromLists(_name, core, lite),
            missing: true
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return modules;
    }
  }, {
    key: "moduleNameFromPath",
    value: function moduleNameFromPath(entry) {
      if (!entry) {
        return '';
      }
      return String(entry).split('/')[0];
    }
  }, {
    key: "modeFromLists",
    value: function modeFromLists(name, core, lite) {
      var on_server = core.has(name);
      var on_client = lite.has(name);
      if (on_server && on_client) {
        return 'both';
      }
      if (on_server) {
        return 'server';
      }
      if (on_client) {
        return 'client';
      }
      return 'off';
    }
  }, {
    key: "nextMode",
    value: function nextMode(name, mode) {
      if (name === 'admin') {
        return mode === 'server' ? 'both' : 'server';
      }
      var order = ['off', 'both', 'server', 'client'];
      var index = order.indexOf(mode);
      return order[(index + 1) % order.length];
    }
  }, {
    key: "applyFilter",
    value: function applyFilter() {
      var q = this.filter.trim().toLowerCase();
      document.querySelectorAll('.admin-module-card').forEach(function (card) {
        var name = card.dataset.module || '';
        card.style.display = !q || name.toLowerCase().includes(q) ? '' : 'none';
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var filter = document.getElementById('admin-modules-filter');
      if (filter) {
        filter.oninput = function (e) {
          _this2.filter = e.currentTarget.value;
          _this2.applyFilter();
        };
      }
      document.querySelectorAll('.admin-module-card').forEach(function (card) {
        card.onclick = function () {
          var name = card.dataset.module;
          var item = _this2.modules.find(function (m) {
            return m.name === name;
          });
          if (!item) {
            return;
          }
          item.mode = _this2.nextMode(item.name, item.mode);
          _this2.dirty = true;
          _this2.saved = false;
          _this2.error = '';
          card.className = "admin-module-card mode-".concat(item.mode).concat(item.missing ? ' missing' : '');
          var badge = card.querySelector('.admin-module-mode');
          if (badge) {
            badge.textContent = MODE_LABELS[item.mode] || item.mode;
          }
          var err = document.querySelector('.admin-modules-error');
          if (err) {
            err.remove();
          }
          var saved = document.querySelector('.admin-modules-saved');
          if (saved) {
            saved.remove();
          }
          var saveBtn = document.getElementById('admin-modules-save');
          if (saveBtn) {
            saveBtn.disabled = false;
            saveBtn.textContent = 'Save';
          }
        };
      });
      var saveBtn = document.getElementById('admin-modules-save');
      if (saveBtn) {
        saveBtn.onclick = function () {
          return _this2.save();
        };
      }
      document.querySelectorAll('.admin-copy-cmd').forEach(function (btn) {
        btn.onclick = function (e) {
          e.stopPropagation();
          var cmd = btn.dataset.cmd;
          if (!cmd) {
            return;
          }
          navigator.clipboard.writeText(cmd).then(function () {
            if (typeof siteMessage === 'function') {
              siteMessage('command copied to clipboard...', 2000);
            }
          });
        };
      });
    }
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this3 = this;
        var saveBtn, core, lite, _iterator3, _step3, item, entry, tx;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              saveBtn = document.getElementById('admin-modules-save');
              if (saveBtn) {
                saveBtn.disabled = true;
                saveBtn.textContent = 'Saving…';
              }
              core = [];
              lite = [];
              _iterator3 = _createForOfIteratorHelper(this.modules);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  item = _step3.value;
                  entry = "".concat(item.name, "/").concat(item.name, ".js");
                  if (item.mode === 'both' || item.mode === 'server') {
                    core.push(entry);
                  }
                  if (item.mode === 'both' || item.mode === 'client') {
                    lite.push(entry);
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              core.sort();
              lite.sort();
              _context.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 1:
              tx = _context.v;
              tx.msg = {
                module: 'Admin',
                request: 'update-modules-config',
                config: JSON.stringify({
                  core: core,
                  lite: lite
                })
              };
              _context.n = 2;
              return tx.sign();
            case 2:
              this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                var res = res_tx.returnMessage();
                if (res !== null && res !== void 0 && res.err) {
                  _this3.error = res.err;
                  _this3.saved = false;
                  _this3.dirty = true;
                  _this3.refresh();
                  return;
                }
                if (_this3.mod.server_info) {
                  _this3.mod.server_info.module_config = {
                    core: core,
                    lite: lite
                  };
                }
                _this3.modules = _this3.buildModuleList();
                _this3.dirty = false;
                _this3.saved = true;
                _this3.error = '';
                _this3.refresh();
                siteMessage('Module configuration saved');
              }, this.mod.server_publickey);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }]);
}();
module.exports = AdminModulesUI;